import { cloneDeep } from "lodash";
import { make } from "vuex-pathify";
import User from "./model";
import store from "../..";
import Axios from "axios";
import { API_URL } from '../../../config'

const user = {
    first_name: null,
    last_name: null,
    position: null,
    email: null,
    api_token: "",
}

const client = {
    name: null,
    currency: null,
    data_started_at: null,
}

const state = {
    user: cloneDeep(user),
    client: cloneDeep(client),
};

const mutations = make.mutations(state);

const actions = {
    async can({ commit }, { ability, model, id }) {
        let response = null
        let url = `${API_URL}/authorize?ability=${ability}`

        if (model) {
            url = `${url}&model=${model}`
        }

        if (id) {
            url = `${url}&id=${id}`
        }

        try {
            response = await Axios.get(url)
        } catch (error) {
            return false
        }

        if (response && response.data && response.data.allowed) {
            return true
        }

        return false
    },

    async loadUser({ commit }) {
        let user = await User
            .custom('user')
            .first()

        commit("user", user);

        if (!store.get("auth/client@id")) {
            if (user.default_client) {
                commit("client", user.default_client);
            } else if (user.clients.length > 0) {
                commit("client", user.clients[0].client);
            }
        }
    },

    logout({ commit }) {
        window.localStorage.clear()
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
